<template>
  <GeneralLinkComponent
    :link="link"
    text=""
    _type="generalLink"
    :class="{
      'cta-button flex items-center gap-1 uppercase': true,
      'text-10px font-bold leading-3 tracking-wider': true,
      'text-www-color-white': true,
      'inline-block px-4': true,
      'transition-all duration-300 hover:text-www-color-primary-lighter': true,
    }"
  >
    <PtcIcon
      :name="iconName"
      :class="{
        'text-sm': true,
      }"
    />
    <span
      :class="{
        'whitespace-nowrap': true,
      }"
      >{{ text }}</span
    >
  </GeneralLinkComponent>
</template>

<script setup lang="ts">
import type { GeneralLink } from '~/sanity/types';
import GeneralLinkComponent from '../HeaderComponents/GeneralLink.vue';
import PtcIcon from '~/components/Atmos/PtcIcon/PtcIcon.vue';
defineProps<GeneralLink & { iconName: string }>();
</script>

<style scoped></style>
